module.exports = __webpack_public_path__ + "static/media/notfound-icon.d3c10e0a.svg";